// Which charts get a pre-visit brief.
import { COMBINED_UUID } from "../../../documentComponents/medStudentCombine";

// A real notes-c visit with a date. Roster (patient-level) charts and the
// combined-day view have no single visit to brief.
export function isBriefEligible(patient) {
  if (!patient || !patient.id || !patient.date_) return false;
  if (patient._source === "roster") return false;
  if (String(patient.id) === COMBINED_UUID) return false;
  return true;
}
